/** ไม่เร่งด่วน / เร่งด่วน — รองรับ priority / urgency / is_urgent จาก API */

export const NOT_URGENT = { label: 'ไม่เร่งด่วน', bgcolor: 'rgba(0, 0, 0, 0.06)', color: 'rgba(0, 0, 0, 0.65)' };
export const URGENT = { label: 'เร่งด่วน', bgcolor: 'rgba(211, 47, 47, 0.12)', color: '#c62828' };

export function isTicketUrgent(ticket) {
  if (!ticket) return false;
  if (ticket.is_urgent === true) return true;
  const raw = ticket.priority ?? ticket.urgency;
  if (raw === null || raw === undefined || raw === '') return false;
  const key = String(raw).toLowerCase().trim();
  if (['urgent', 'high', 'critical', 'true', 'yes', '1'].includes(key)) return true;
  if (['normal', 'low', 'medium', 'false', 'no', '0'].includes(key)) return false;
  const n = Number(raw);
  if (!Number.isNaN(n)) return n >= 2;
  return false;
}

export function getUrgencyDisplay(ticket) {
  return isTicketUrgent(ticket) ? URGENT : NOT_URGENT;
}
